import {doRequest} from '../../../helpers/network';
import {REQUEST_TYPE} from '../../../constants';

const INITIAL_STATE = {
  advanceModal: false,
  loading: false,
  downloadingProcessData: false,
  paymentApprovalData: null,
  externalPartyData: null,
  externalPartyLoading: false,
  clearSearchInputField: false,
  billing_entity: null,
  selectedEntity: 'zast',
  activeAdvanceType: 1,
};

const PA_DOWNLOAD_PROCESS_DATA = 'PA_DOWNLOAD_PROCESS_DATA';
const PA_DOWNLOAD_PROCESS_DATA_COMPLETED = 'PA_DOWNLOAD_PROCESS_DATA_COMPLETED';
const PA_DOWNLOAD_PROCESS_DATA_FAILED = 'PA_DOWNLOAD_PROCESS_DATA_FAILED';
const PA_CLEAR_SEARCH_INPUT = 'PA_CLEAR_SEARCH_INPUT';
const PA_EXTERNAL_PARTY_LOADING = 'PA_EXTERNAL_PARTY_LOADING';
const PA_EXTERNAL_PARTY_FETCH_SUCCESS = 'PA_EXTERNAL_PARTY_FETCH_SUCCESS';
const PA_EXTERNAL_PARTY_FETCH_FAILED = 'PA_EXTERNAL_PARTY_FETCH_FAILED';

export const clearSearchInput = (data) => ({
  type: PA_CLEAR_SEARCH_INPUT,
  payload: data,
});

export const setSelectedEntity = (entity) => ({
  type: 'PA_SET_SELECTED_ENTITY',
  payload: entity,
});

export const setActiveAdvanceType = (advanceType) => ({
  type: 'PA_SET_ACTIVE_ADVANCE_TYPE',
  payload: advanceType,
});

export const sendUtrData = (sendData) => {
  return async (dispatch) => {
    let response = {};
    try {
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: 'finance/update-utr',
        data: sendData,
      });
    } catch (err) {}
    return response;
  };
};

export const getPaymentApprovalData = (
  businessType,
  advanceType,
  search = '',
) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: 'PA_LOADING'});
      const baseUrl = `finance/payment-approvals/?business_type=${businessType}&advance_type=${advanceType}`;
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: search ? `${baseUrl}${search}` : baseUrl,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: 'PA_FETCH_DATA_SUCCESS',
          payload: data,
          businessType,
        });
      }
    } catch (err) {}
    return response;
  };
};

export const getExternalPartyData = (businessType, search = '') => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: PA_EXTERNAL_PARTY_LOADING});
      const baseUrl = businessType
        ? `finance/external-party-banking-request/?business_type=${businessType}`
        : `finance/external-party-banking-request/`;
      const url = search
        ? `${baseUrl}${baseUrl.includes('?') ? '' : '?'}${search}`
        : baseUrl;
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: PA_EXTERNAL_PARTY_FETCH_SUCCESS,
          payload: data,
          businessType,
        });
      } else {
        dispatch({type: PA_EXTERNAL_PARTY_FETCH_FAILED});
      }
    } catch (err) {
      dispatch({type: PA_EXTERNAL_PARTY_FETCH_FAILED});
    }
    return response;
  };
};

const processPaymentAction = (url) => (payload) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: PA_DOWNLOAD_PROCESS_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url,
        data: payload,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({type: PA_DOWNLOAD_PROCESS_DATA_COMPLETED});
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: PA_DOWNLOAD_PROCESS_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: PA_DOWNLOAD_PROCESS_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const approvePaymentApproval = processPaymentAction(
  'finance/payment-approvals/approve/',
);
export const rejectPaymentApproval = processPaymentAction(
  'finance/payment-approvals/reject/',
);
export const approveExternalPartyPayments = processPaymentAction(
  'finance/external-party-banking-request/approve/',
);

export const openAdvanceModals = () => ({type: 'PA_ADVANCE_MODAL_OPEN'});

export const closeAdvanceModals = () => ({type: 'PA_ADVANCE_MODAL_CLOSE'});

export const setBillingEntity = (data) => ({
  type: 'PA_SET_BILLING_ENTITY',
  payload: data,
});

export const unsetBillingEntity = () => ({type: 'PA_UNSET_BILLING_ENTITY'});

export const getFilterDataRequest = (businessType, advanceType, url) => {
  return async (dispatch) => {
    let response = {};
    dispatch({type: 'PA_SAVE_MY_PROCESS_REQUEST', payload: url});
    try {
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: `finance/payment-approvals/?business_type=${businessType}&advance_type=${advanceType}${url}`,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: 'PA_FETCH_DATA_SUCCESS',
          payload: data,
        });
      }
    } catch (err) {}
    return response;
  };
};

export const savePendingFilterData = (url) => ({
  type: 'PA_SAVE_MY_PENDING_URL',
  payload: url,
});

export const saveProcessFilterData = (url) => ({
  type: 'PA_SAVE_MY_PROCESS_REQUEST_FILTER',
  payload: url,
});

// businessType ('Zast'/'Transin') maps to the entity key ('zast'/'transin').
const entityForBusinessType = (businessType) =>
  typeof businessType === 'string' ? businessType.toLowerCase() : null;

export default (state = INITIAL_STATE, action) => {
  const {type, payload} = action;
  switch (type) {
    case PA_CLEAR_SEARCH_INPUT:
      return {
        ...state,
        clearSearchInputField: payload,
      };
    case 'PA_SET_SELECTED_ENTITY':
      // Switching entity: drop the previous entity's data so its amounts/rows
      // never flash in the newly-selected tab before the refetch resolves.
      if (payload === state.selectedEntity) return state;
      return {
        ...state,
        selectedEntity: payload,
        paymentApprovalData: null,
        externalPartyData: null,
      };
    case 'PA_SET_ACTIVE_ADVANCE_TYPE':
      return {
        ...state,
        activeAdvanceType: payload,
      };
    case 'PA_ADVANCE_MODAL_OPEN':
      return {
        ...state,
        advanceModal: true,
      };
    case 'PA_ADVANCE_MODAL_CLOSE':
      return {
        ...state,
        advanceModal: false,
      };
    case 'PA_SET_BILLING_ENTITY':
      return {
        ...state,
        billing_entity: payload,
      };
    case 'PA_UNSET_BILLING_ENTITY':
      return {
        ...state,
        billing_entity: null,
      };
    case 'PA_SAVE_MY_PENDING_URL':
      return {
        ...state,
        currentPendingFilterData: payload,
      };
    case 'PA_SAVE_MY_PROCESS_REQUEST':
      return {
        ...state,
        currentProcessFilterData: payload,
        loading: true,
      };
    case 'PA_FETCH_DATA_SUCCESS': {
      // Ignore a late response that belongs to a no-longer-selected entity,
      // otherwise it would overwrite the current entity's data.
      const entity = entityForBusinessType(action.businessType);
      if (entity && entity !== state.selectedEntity) return state;
      return {
        ...state,
        paymentApprovalData: payload,
        filters: payload.filters,
        loading: false,
      };
    }
    case 'PA_LOADING':
      return {
        ...state,
        loading: true,
      };
    case PA_DOWNLOAD_PROCESS_DATA:
      return {
        ...state,
        downloadingProcessData: true,
        error: '',
      };
    case PA_DOWNLOAD_PROCESS_DATA_COMPLETED:
      return {
        ...state,
        downloadingProcessData: false,
      };
    case PA_DOWNLOAD_PROCESS_DATA_FAILED:
      return {
        ...state,
        downloadingProcessData: false,
        error: payload.error,
      };
    case PA_EXTERNAL_PARTY_LOADING:
      return {
        ...state,
        externalPartyLoading: true,
      };
    case PA_EXTERNAL_PARTY_FETCH_SUCCESS: {
      const entity = entityForBusinessType(action.businessType);
      if (entity && entity !== state.selectedEntity) return state;
      return {
        ...state,
        externalPartyData: payload,
        externalPartyLoading: false,
      };
    }
    case PA_EXTERNAL_PARTY_FETCH_FAILED:
      return {
        ...state,
        externalPartyLoading: false,
      };
    default:
      return state;
  }
};
